<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content w-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="经销商编码/名称" prop="agentCode">
                <el-input v-model="q.agentCode" placeholder="请输入经销商编码或名称"></el-input>
              </el-form-item>
<!--              <el-form-item label="经销商名称" prop="agentName">
                <el-input v-model="q.agentName" placeholder="请输入"></el-input>
              </el-form-item>-->
              <el-form-item label="渠道" prop="channelCode">
                <brselect category="fl_sales_region_main" :v="q.channelCode" v-model="q.channelCode" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
<!--              <el-form-item label="返利归属产业" prop="belongIndustry">-->
<!--                <brselect category="fl_belong_industry" :v="q.belongIndustry" v-model="q.belongIndustry" :multiple="true"-->
<!--                          :clearable="true"/>-->
<!--              </el-form-item>-->
              <el-form-item label="签约链群" prop="rebateChainGroup">
                <brselect category="fl_25_chain_group" :v="q.rebateChainGroup" v-model="q.rebateChainGroup" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
            </div>
            <el-collapse-transition>
              <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="状态" prop="channel">
                    <brselect category="fl_lvyue_quit_status" :v="q.isUse" v-model="q.isUse"
                              :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="区域" prop="area">
                    <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :multiple="true"
                              :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="经销商类型" prop="agentNameLike">
                    <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
                  </el-form-item>
<!--                  <el-form-item label="领域" prop="field">-->
<!--                    <brselect category="fl_field" :v="q.field" v-model="q.field"-->
<!--                              :clearable="true"/>-->
<!--                  </el-form-item>-->
                </div>
                <div class="h-thirdColumn w-newColumn">
<!--                  <el-form-item label="所属链群" prop="contractId">-->
<!--                    <brselect category="fl_contract_id" :v="q.contractId" v-model="q.contractId" :clearable="true"/>-->
<!--                  </el-form-item>-->
                </div>
              </div>
            </el-collapse-transition>
            <div class="l-screenBox">
              <div class="l-screen" @click="collapseChange">
                <img :src="isScreen?closeScreen:drawScreen" alt="">
                <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
              </div>
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table :model="q"
                  ref="q"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  :summary-method="getSummaries"
                  show-summary
                  max-height="530"
        >
          <el-table-column
              prop="area"
              :show-overflow-tooltip="true"
              label="区域"
              width="80"
              fixed
          >
          </el-table-column>
          <el-table-column
                  prop="agentType"
                  :show-overflow-tooltip="true"
                  label="经销商类型"
                  width="80"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.agentType|dictname('fl_agent_type')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentCode"
              :show-overflow-tooltip="true"
              label="经销商编码"
              width="110"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentCode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentName"
              :show-overflow-tooltip="true"
              label="经销商名称"
              min-width="180"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentName }}
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--              prop="contractId"-->
<!--              :show-overflow-tooltip="true"-->
<!--              label="所属链群"-->
<!--              width="80">-->
<!--            <template slot-scope="scope">-->
<!--              <div style="text-align: left;">-->
<!--                {{scope.row.contractId|dictname('fl_contract_id')}}-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--                prop="field"-->
<!--                :show-overflow-tooltip="true"-->
<!--                label="领域"-->
<!--                width="80"-->
<!--                fixed-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            <div style="text-align: left;">-->
<!--              {{scope.row.field|dictname('fl_field')}}-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
          <el-table-column
              prop="channelCode"
              :show-overflow-tooltip="true"
              label="渠道"
              width="100"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.channelCode|dictname('fl_sales_region_main')}}
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--              prop="belongIndustry"-->
<!--              :show-overflow-tooltip="true"-->
<!--              label="返利归属产业"-->
<!--              width="90"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--              <div style="text-align: left;">-->
<!--                {{ scope.row.belongIndustry|dictname('fl_belong_industry')}}-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
              prop="rebateChainGroup"
              :show-overflow-tooltip="true"
              label="签约链群"
              width="100"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.rebateChainGroup|dictname('fl_25_chain_group')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="1月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi1"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi1).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="janM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.janM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jan"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.jan).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="janL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{ (Number(scope.row.janL).toFixed(2)) + '%' }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="2月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi2"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi2).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="febM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.febM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="feb"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.feb).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="febL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.febL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="3月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi3"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi3).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="marM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.marM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mar"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.mar).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="marL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.marL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="一季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="firstQuarterT"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="firstQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.firstQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="4月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi4"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi4).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aprM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.aprM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="apr"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.apr).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aprL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.aprL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="5月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi5"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi5).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mayM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.mayM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="may"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.may).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="mayL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.mayL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="6月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi6"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi6).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="junM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.junM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jun"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.jun).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="junL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.junL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="二季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="secondQuarterT"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="secondQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.secondQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="7月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi7"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi7).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="julM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.julM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jul"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.jul).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="julL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.julL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="8月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi8"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi8).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="augM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.augM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="aug"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.aug).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="augL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.augL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="9月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi9"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi9).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sepM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sepM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sep"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sep).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sepL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.sepL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="三季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="thirdQuarterT"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thirdQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.thirdQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="10月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi10"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi10).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="octM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.octM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="oct"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.oct).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="octL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.octL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="11月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi11"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi11).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="novM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.novM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="nov"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.nov).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="novL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.novL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="12月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi12"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi12).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="deceM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.deceM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="dece"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.dece).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="deceL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.deceL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="四季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="fourthQuarterT"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarterT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarterM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarterM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarter"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarter).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="fourthQuarterL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.fourthQuarterL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="全年合计" :show-overflow-tooltip="true">
            <el-table-column
                    prop="yearT"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearT).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearM"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearM).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearS"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearS).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="yearL"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.yearL).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
              prop="isUse"
              :show-overflow-tooltip="true"
              label="状态"
              width="80"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.isUse | dictname('fl_lvyue_quit_status')}}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel" v-auth="'khlybbXs_daochu'">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'

export default {
  components: {},
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        agentName: '',
        agentCode: '',
        channel: null,
        // 血液履约报表默认签约链群：血液网、血液网-传统（字典 code：ND5、BCT）
        rebateChainGroup: ['ND5', 'BCT'],
        year: 2024,
        type: '',
        areaCode: null,
        isUse:'',
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      //table列表
      tableData: [],
      countlist:'',
    }
  },
  created() {
    this.q = {
      agentName: '',
      agentCode: '',
      channel: null,
      rebateChainGroup: ['ND5', 'BCT'],
      type: '',
      isUse: 0,
      areaCode: null,
      pageSize: 10,
      pageNo: 1,
      total: 0
    };
    this.q.agentCode = this.$route.query.agentCode || '';
    this.handleFilter();
  },
  methods: {
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    //检索
    handleFilter() {
      this.query();
      this.queryTotal();
    },
    // 构建请求参数（后端签约链群为逗号分隔字符串）
    getQueryParams() {
      const q = { ...this.q };
      if (Array.isArray(q.rebateChainGroup)) {
        q.rebateChainGroup = q.rebateChainGroup.length ? q.rebateChainGroup.join(',') : '';
      }
      return q;
    },
    //重置
    reset() {
      this.q = {
        agentType: '',
        agentName: '',
        agentCode: '',
        channel: null,
        rebateChainGroup: ['ND5', 'BCT'],
        belongIndustry: null,
        type: '',
        isUse: 0,
        areaCode: null,
        pageSize: 10,
        pageNo: 1,
        total: 0
      };
      this.handleFilter();
    },
    //查询table
    query() {
      ss.fanli.getLyLqPage(this.getQueryParams()).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    queryTotal() {
      ss.fanli.getLyLqTotal(this.getQueryParams()).then(rd => {
        this.countlist = rd;
      });
    },
    //批量导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/fl/flQudaoSalesVolume/downloadExcelLvyueLq", this.getQueryParams(), "post");
    },
    // 求和汇总（按 column.property 对齐，隐藏列后合计不错位）
    getSummaries(param) {
      const { columns } = param;
      const c = this.countlist;
      const sums = [];
      // 履约率列（*L）用 销额/目标 计算
      const rate = (m, v) => (m ? (Number(v) * 100 / Number(m)).toFixed(2) + '%' : '0.00%');
      const num = (v) => Number(v).toFixed(2);
      const propMap = {
        tongqi1: () => num(c.tongqi1), janM: () => num(c.janM), jan: () => num(c.jan), janL: () => rate(c.janM, c.jan),
        tongqi2: () => num(c.tongqi2), febM: () => num(c.febM), feb: () => num(c.feb), febL: () => rate(c.febM, c.feb),
        tongqi3: () => num(c.tongqi3), marM: () => num(c.marM), mar: () => num(c.mar), marL: () => rate(c.marM, c.mar),
        firstQuarterT: () => num(c.firstQuarterT), firstQuarterM: () => num(c.firstQuarterM), firstQuarter: () => num(c.firstQuarter), firstQuarterL: () => rate(c.firstQuarterM, c.firstQuarter),
        tongqi4: () => num(c.tongqi4), aprM: () => num(c.aprM), apr: () => num(c.apr), aprL: () => rate(c.aprM, c.apr),
        tongqi5: () => num(c.tongqi5), mayM: () => num(c.mayM), may: () => num(c.may), mayL: () => rate(c.mayM, c.may),
        tongqi6: () => num(c.tongqi6), junM: () => num(c.junM), jun: () => num(c.jun), junL: () => rate(c.junM, c.jun),
        secondQuarterT: () => num(c.secondQuarterT), secondQuarterM: () => num(c.secondQuarterM), secondQuarter: () => num(c.secondQuarter), secondQuarterL: () => rate(c.secondQuarterM, c.secondQuarter),
        tongqi7: () => num(c.tongqi7), julM: () => num(c.julM), jul: () => num(c.jul), julL: () => rate(c.julM, c.jul),
        tongqi8: () => num(c.tongqi8), augM: () => num(c.augM), aug: () => num(c.aug), augL: () => rate(c.augM, c.aug),
        tongqi9: () => num(c.tongqi9), sepM: () => num(c.sepM), sep: () => num(c.sep), sepL: () => rate(c.sepM, c.sep),
        thirdQuarterT: () => num(c.thirdQuarterT), thirdQuarterM: () => num(c.thirdQuarterM), thirdQuarter: () => num(c.thirdQuarter), thirdQuarterL: () => rate(c.thirdQuarterM, c.thirdQuarter),
        tongqi10: () => num(c.tongqi10), octM: () => num(c.octM), oct: () => num(c.oct), octL: () => rate(c.octM, c.oct),
        tongqi11: () => num(c.tongqi11), novM: () => num(c.novM), nov: () => num(c.nov), novL: () => rate(c.novM, c.nov),
        tongqi12: () => num(c.tongqi12), deceM: () => num(c.deceM), dece: () => num(c.dece), deceL: () => rate(c.deceM, c.dece),
        fourthQuarterT: () => num(c.fourthQuarterT), fourthQuarterM: () => num(c.fourthQuarterM), fourthQuarter: () => num(c.fourthQuarter), fourthQuarterL: () => rate(c.fourthQuarterM, c.fourthQuarter),
        yearT: () => num(c.yearT), yearM: () => num(c.yearM), yearS: () => num(c.yearS), yearL: () => rate(c.yearM, c.yearS)
      };
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }
        const prop = column.property;
        if (prop && propMap[prop]) {
          sums[index] = propMap[prop]();
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  }
}
</script>
<style lang="scss">
.el-table thead.is-group th {
  background-color: #57aefe;
}

.w-content .el-table__footer-wrapper .cell {
  text-align: right;
}

.w-content .el-table__fixed-footer-wrapper tbody td {
  background: #cce7ff;
}

.w-content .el-table__footer-wrapper tbody td {
  background: #cce7ff;
}

.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

.el-table__fixed, .el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed, .el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: '';
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .12);
  }
}

.el-table__fixed-footer-wrapper tbody td {
  border-top: 0;
}
</style>
